import { useEffect } from 'react';
import { fetchTenantTheme } from '../../../application/landing/themeService';
import { readBrowserHostname } from '../../../features/navigation/presentation/browserNavigationSupport';

const SKIP_HOSTNAMES = new Set(['localhost', '127.0.0.1', '0.0.0.0']);
const SKIP_SUFFIXES = ['.cloudfront.net', '.amazonaws.com'];
// Platform-owned subdomains, never workspace tenants — the canonical app
// host (app.octopusintl.org) would otherwise request /landing/theme/app/
// on every page load and 404 forever.
const SKIP_SUBDOMAINS = new Set(['app', 'www', 'api']);

const resolveTenantFromHost = () => {
  const tenantURL = readBrowserHostname();
  if (!tenantURL || SKIP_HOSTNAMES.has(tenantURL)) return '';
  if (SKIP_SUFFIXES.some((suffix) => tenantURL.endsWith(suffix))) return '';
  const subdomain = tenantURL.split('.')[0];
  if (SKIP_SUBDOMAINS.has(subdomain)) return '';
  return subdomain;
};

export const useThemeBootstrapPresentation = ({ dispatch, actions }) => {
  useEffect(() => {
    const getThemeData = async () => {
      try {
        const tenant = resolveTenantFromHost();
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 8000);
        const data = await fetchTenantTheme({
          tenant,
          signal: controller.signal
        });
        clearTimeout(timeoutId);
        if (!data) {
          return;
        }
        dispatch({ type: actions.SET_THEME, payload: data });
      } catch (err) {
        if (process.env.NODE_ENV !== 'production') {
          console.warn('Theme load skipped/failed:', err?.message || err);
        }
      }
    };

    getThemeData();
  }, [actions.SET_THEME, dispatch]);
};
